import serviceimg from '../../../assets/images/SServices.png';
import PageHeader from '@/components/PageHeader';

function AnalyticalDevelopmentAndMicrobiologyServices() {
  return (
    <div className="font-sans">

      <PageHeader title='Our Services' imageUrl={serviceimg} breadcrumbs={['Home', 'Our Services', 'Pharmaceutical Product Development & Project Management', 'Analytical Development & Microbiology Services']} />

      <div className="max-w-[var(--max-width)] mx-auto px-4 sm:px-6 md:px-12 lg:px-20 xl:px-32 py-12 text-[#05326D]">

        <h2 className="text-xl font-bold text-[#05326D] flex items-center gap-2 mb-12">
          <span className="inline-block w-[6px] h-5 rounded-tr-sm rounded-br-sm bg-[#B5AB28]"></span>
          Pharmaceutical Product Development & Project Management
        </h2>

        {/* Section Title */}
        <div className="flex items-center gap-2 mb-4">
          <span className="w-4 h-4 rounded-full bg-sky-300 flex-shrink-0 flex-shrink-0"></span>
          <h3 className="text-lg font-bold text-[#05326D]">
            Analytical Development & Microbiology Services
          </h3>
        </div>


        {/* Intro */}
        <p className="text-sm text-[#05326D] mb-2 font-bold">
          End-to-End Analytical Solutions for APIs, Formulations & Global Regulatory Compliance
        </p>
        <p className="mb-4 text-sm text-[#05326D]">
          At FDAC Consultancy, we understand that robust analytical development is the backbone of pharmaceutical quality and regulatory success. With decades of industry experience and strategic partnerships with state-of-the-art CROs, we deliver comprehensive analytical services for formulations, APIs, and excipients—tailored to meet the requirements of US FDA, EU Health Authorities, MHRA, CDSCO, LATAM, GCC, South Africa, and other global markets.
        </p>
        <p className="mb-8 text-sm text-[#05326D]">
          From method development to validation, stability studies to microbiological testing, FDAC offers a full spectrum of analytical support aligned with ICH guidelines and international pharmacopoeias.
        </p>

        <hr className="border-t border-gray-300 mb-8" />

        <div className="flex items-center gap-2 mb-4 mt-4">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-md font-bold text-[#05326D]">
            Core Analytical Development Services
          </span>
        </div>

        <p className="ml-2 mt-2 text-[#05326D]">Analytical Method Development & Validation</p>
        <p className="ml-2 mt-2 text-[#05326D]">Impurity Profiling & Characterization</p>
        <p className="ml-2 mt-2 text-[#05326D]">Raw Material Qualification & Structure Elucidation</p>
        <p className="ml-2 mt-2 text-[#05326D]">Analysis as per USP, EP, BP, IP, CP, JP</p>
        <p className="ml-2 mt-2 text-[#05326D]">Stability Studies:</p>
        <p className="ml-2 mt-2 text-[#05326D]">Zone-specific stability chambers</p>
        <p className="ml-2 mt-2 text-[#05326D]">Photostability, Bulk & In-use stability</p>
        <p className="ml-2 mt-2 text-[#05326D]">Forced Degradation Studies</p>
        <p className="ml-2 mt-2 text-[#05326D]">Dissolution Profiling & Solubility Studies</p>
        <p className="ml-2 mt-2 text-[#05326D]">Trace Metal & Elemental Impurity Analysis</p>
        <p className="ml-2 mt-2 text-[#05326D]">Routine & Specialized Testing</p>
        <p className="ml-2 mt-2 text-[#05326D]">API Characterization & Documentation (ICH-Compliant)</p>
        <p className="ml-2 mt-2 text-[#05326D]">Method Transfer to CMO Sites</p>
        <p className="ml-2 mt-2 text-[#05326D]">Nitrosamine Risk Assessment & Analytical Validation</p>
        <p className="ml-2 mt-2 text-[#05326D]">Support for NDA, ANDA, 505(b)(1), 505(b)(2), EU-MAA, RoW Submissions</p>
        <p className="ml-2 mt-2 text-[#05326D]">Paragraph I–IV Development Strategies</p>


        {/* Genotoxicity Assessment Services */}

        <div className="flex items-center gap-2 mb-4 mt-4">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-md font-bold text-[#05326D]">
            Genotoxicity Assessment Services
          </span>
        </div>
        <p className="text-sm mb-3 text-[#05326D]">
          FDAC offers advanced in silico genotoxicity evaluations using industry-standard platforms:
        </p>
        <p className="ml-2 mt-2 text-[#05326D]">(Q)SAR-Based Assessments using:</p>
        <p className="ml-2 mt-2 text-[#05326D]">Derek Nexus (Knowledge-Based)</p>
        <p className="ml-2 mt-2 text-[#05326D]">TOPKAT (Statistical-Based)</p>
        <p className="ml-2 mt-2 text-[#05326D]">MultiCase Software</p>
        <p className="ml-2 mt-2 text-[#05326D]">Alert Identification & Risk Profiling</p>
        <p className="ml-2 mt-2 text-[#05326D]">Automated Prediction Reports with Expert Review</p>
        <p className="ml-2 mt-2 text-[#05326D]">Signed, Comprehensive Genotoxicity Reports</p>


        {/* Microbiology Capabilities */}


        <div className="flex items-center gap-2 mb-4 mt-4">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-md font-bold text-[#05326D]">
            Microbiology Capabilities
          </span>
        </div>

        <p className="text-sm mb-3 text-[#05326D]">
          Our microbiology services support product safety, environmental control, and regulatory compliance:
        </p>
        <p className="ml-2 mt-2 text-[#05326D]">Microbial Limit Testing</p>
        <p className="ml-2 mt-2 text-[#05326D]">Antimicrobial Efficacy Testing</p>
        <p className="ml-2 mt-2 text-[#05326D]">Environmental Monitoring:</p>
        <p className="ml-2 mt-2 text-[#05326D]">Settle Plates, Air Sampling, Finger Dab, Contact Plates, Swab Analysis</p>
        <p className="ml-2 mt-2 text-[#05326D]">Water Analysis (Chemical & Microbial)</p>
        <p className="ml-2 mt-2 text-[#05326D]">Bacterial Endotoxin Testing</p>
        <p className="ml-2 mt-2 text-[#05326D]">Antibiotic & Vitamin Assays</p>
        <p className="ml-2 mt-2 text-[#05326D]">Raw Material & Excipient Testing (Pharmacopoeial Standards)</p>
        <p className="ml-2 mt-2 text-[#05326D]">Disinfectant Effectiveness Testing</p>


        {/* Infrastructure & Equipment */}

        <div className="flex items-center gap-2 mb-4 mt-4">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-md font-bold text-[#05326D]">
            Infrastructure & Equipment
          </span>
        </div>
        <p className="text-sm mb-3 text-[#05326D]">
          Our partner labs are equipped with cutting-edge instrumentation to support diverse analytical needs:
        </p>
        <p className="ml-2 mt-2 text-[#05326D]">HPLC, GC, LC/MS, IR & UV Spectrophotometers</p>
        <p className="ml-2 mt-2 text-[#05326D]">AAS, DSC, Potentiometers, Karl Fischer Titrators</p>
        <p className="ml-2 mt-2 text-[#05326D]">Dissolution Apparatus & Stability Chambers …and more, enabling precision across all testing scales.</p>


        {/* Why FDAC */}
        <div className="flex items-center gap-2 mb-4 mt-4">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-md font-bold text-[#05326D]">
            Why FDAC?
          </span>
        </div>
        <p className="ml-2 mt-2 text-[#05326D]">Global regulatory alignment across major markets</p>
        <p className="ml-2 mt-2 text-[#05326D]">Expert CRO selection based on product type and analytical complexity</p>
        <p className="ml-2 mt-2 text-[#05326D]">Full-spectrum analytical support from development to dossier submission</p>
        <p className="ml-2 mt-2 text-[#05326D]">Proven expertise in method validation, genotoxicity, and microbiology</p>
        <p className="ml-2 mt-2 text-[#05326D]">For customized analytical solutions, contact: info@fdcadvancedsolutions.com</p>

      </div>
    </div>
  );
}

export default AnalyticalDevelopmentAndMicrobiologyServices;
